module.exports = __webpack_public_path__ + "static/media/logout-purple.658eb7af.svg";